import { useEffect } from "react";
import { app } from "@microsoft/teams-js";
import { selectCurrentUser, selectIsAuthLoading } from "../store/auth.duck";
import { useDispatch, useSelector } from "react-redux";
import { agent } from '@shared/services/agent';
import { isInTeams } from '@shared/utils/TeamsUtils';

export function WithMsTeamsNewUserChecker() {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const isAuthLoading = useSelector(selectIsAuthLoading);

  useEffect(() => {
    let id: any;
    if (isInTeams()) {
      if (!isAuthLoading && !currentUser) {
        id = setTimeout(() => {
          app.initialize().then(() => app.getContext()).then((ctx: app.Context) => {
            if (ctx.user?.userPrincipalName) {
              agent.requests.post('/teams-ping', {c: ctx.user?.userPrincipalName}, true)
            }
          }).catch(() => {
      // Teams SDK context is unavailable outside Teams — nothing to do.
    });
        }, 500)
      }
    }
    return () => {
      if (id) {
        clearTimeout(id);
      }
    }
  }, [currentUser, dispatch, isAuthLoading]);
}
